import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  TextField,
  Button,
  Checkbox,
  Grid,
  Paper,
  Icon,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
} from "@material-ui/core";

import { Box, Select, FormControl, MenuItem, InputLabel } from "@mui/material";

import { loginUser } from "../../redux/actions/userActions";
import { addRegister } from "../../redux/actions/registerAction";
import Loading from "../../components/Loading";
import Error from "../../components/Error";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Navbar/Footer";
import Sidebar from "../../components/Sidebar";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";

export default function Login() {
  const classes = useStyles();



  const [name, set_name] = React.useState("");
  const [email, set_email] = useState("");
  const [phone, set_phone] = useState("");
  const [subject, set_subject] = useState("");
  const [state, set_state] = useState("");
  const [country, set_country] = useState("");
  const [message, set_message] = useState("");

  const [errors, seterrors] = useState([]);

  //

  const [is_edit, setis_edit] = useState(false);

  //

  const loginstate = useSelector((state) => state.loginUserReducer);
  const { error, loading } = loginstate;

  const dispatch = useDispatch();

  useEffect(() => { }, []);

  const handleClear = () => {

    set_name("");
    set_email("");
    set_phone("");
    set_subject("");
    set_state("");
    set_country("");
    set_message("");
  };

  const onChangeContact = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      //this.setState({value: e.target.value})
      set_phone(e.target.value);
      if (e.target.value.length > 10) {
        errors.phone = true;
      } else {
        errors.phone = false;
      }
    }
  };
  const onChangeEmail = (e) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    set_email(e.target.value);
    if (!emailRegex.test(e.target.value)) {
      errors.email = true;
    } else {
      errors.email = false;
    }
  };


  const Submit = () => {
    const reg_data = {
      name,
      email,
      phone,
      subject,
      state,
      country,
      message
    };
    console.log("##### REG DATA  ######", reg_data);
    const errors = validate(reg_data);
    console.log("##### ERRORS  ######", errors);
    seterrors(errors);

    if (Object.keys(errors).length === 0) {
      dispatch(addRegister(reg_data)).then((response) => {
        console.log("@#@#@#@#", response.response.data.msg);
        alert(response.response.data.msg);
        handleClear();
      });
    } else {
      console.log("@#@#@#@#", errors);
    }
  };

  const validate = (data) => {
    const errors = {};
    console.log("-------- DATA  -------", data);

    if (!data.name) {
      errors.name = "*";
    }

    if (!data.email) {
      errors.email = true;
    } else {
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailRegex.test(data.email)) {
        errors.email = true;
      }
    }


    // if (!data.phone || data.phone.length > 10) {
    //   errors.phone = true;
    // }

    if (data.phone.length > 10) {
      errors.phone = true;
    }

    // if (!data.phone.length < 1) {
    //   if (!data.phone || data.phone.length > 10) {
    //     errors.phone = true;
    //   }
    // }


    if (!data.subject) {
      errors.subject = "*";
    }

    // if (!data.state) {
    //   errors.state = "*";
    // }

    // if (!data.country) {
    //   errors.country = "*";
    // }

    if (!data.message) {
      errors.message = "*";
    }

    return errors;
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper1}>
          </Paper>

          <Navbar />



        </Grid>
      </Grid>


      <Grid container spacing={3}>
        <Grid item xs={12}>

          <section class="section pb-0">
            <h3 className="section-title" style={{ textAlign: 'center' }}>Contact Us</h3>
            <div class="container">

              <div class="row">

                <div class="col-md-4 mb-4 mb-md-0">
                  <div class="bg-white box-shadow text-center p-5 px-md-2 px-lg-5" style={{ borderTop: '0.5rem solid #000' }}>
                    <i class="fa fa-map-marker text-primary icon-lg mb-4"></i>
                    <h4 class="mb-4">Our Address</h4>

                    <ul class="list-unstyled">
                      <h4 class="text-dark mb-2"> Headquarters - USA  </h4>
                      <li class="text-dark mb-3"> V3 Data Intelligence Inc, 28175 Haggerty Road, Novi, Michigan 48377,</li>
                      <h4 class="text-dark mb-2"> Headquarters - INDIA  </h4>
                      <li class="text-dark mb-3"> V3 Data Intelligence Inc, Akshaya Arcade, 1st Floor, Vellingiri Nagar, Navavoor Pirivu, Coimbatore, 641046
                      </li>


                    </ul>
                  </div>
                </div>

                <div class="col-md-4 mb-4 mb-md-0">
                  <div class="bg-white box-shadow text-center p-5 px-md-2 px-lg-5" style={{ borderTop: '0.5rem solid #000' }}>
                    <i class="fa fa-phone text-primary icon-lg mb-4"></i>
                    <h4 class="mb-4">Phone Number</h4>
                    <ul class="list-unstyled">
                      <h4 class="text-dark text-dark mb-2"> Headquarters - USA  </h4>
                      <li class="text-dark mb-3"> Phone: +1- (248) 843-0216 </li>
                      <h4 class="text-dark mb-2"> Headquarters - INDIA  </h4>
                      <li class="text-dark mb-3"> Phone: 0422 - 4643944 / 0422 - 4984367</li>
                    </ul>
                  </div>
                </div>

                <div class="col-md-4 mb-4 mb-md-0">
                  <div class="bg-white box-shadow text-center p-5 px-md-2 px-lg-5" style={{ borderTop: '0.5rem solid #000' }}>
                    <i class="fa fa-envelope text-primary icon-lg mb-4"></i>
                    <h4 class="mb-4">Message Us</h4>
                    <ul class="list-unstyled">
                      <h4 class="text-dark mb-2"> Headquarters - USA  </h4>
                      <li class="text-dark mb-3">Email: accounts@streamlineits.com </li>
                      <h4 class="text-dark mb-2"> Headquarters - INDIA  </h4>
                      <li class="text-dark mb-3"> Email: info@v3dataintel.com </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </Grid>
      </Grid>


      <Grid container spacing={3} className="box-shadow mb-4">

        <Grid item xs={1} sm={2}>
          {/* <Paper className={classes.paper}>
            <Sidebar title="Author Registration" />
          </Paper> */}
        </Grid>

        <Grid item xs={10} sm={8} style={{ marginTop: "5rem" }}>
          <Paper className={classes.paper}>





            <h3 className="section-title">Contact Form</h3>
            <Grid container spacing={3} className="mt-0">


              <Grid item xs={12} sm={12} md={6} >
                <TextField
                  id="outlined-basic"
                  label="Name"
                  onChange={(e) => {
                    set_name(e.target.value);
                  }}
                  value={name}
                  variant="outlined"
                  fullWidth={true}
                  autoFocus={true}
                  error={errors.name ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  id="outlined-basic"
                  label="Email"
                  onChange={(e) => onChangeEmail(e)}
                  variant="outlined"
                  value={email}
                  fullWidth={true}
                  autoFocus={false}
                  error={errors.email ? true : false}
                />
              </Grid>


            </Grid>
            <br /> <br />
            <Grid container spacing={3}>

              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  id="outlined-basic"
                  label="Contact Number"
                  // onChange={onChangeContact}
                  onChange={(e) => onChangeContact(e)}
                  variant="outlined"
                  value={phone}
                  fullWidth={true}
                  autoFocus={false}
                  error={errors.phone ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  id="outlined-basic"
                  label="Subject"
                  onChange={(e) => {
                    set_subject(e.target.value);
                  }}
                  value={subject}
                  variant="outlined"
                  fullWidth={true}
                  autoFocus={true}
                  error={errors.subject ? true : false}
                />
              </Grid>

            </Grid>
            <br /> <br />
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  id="outlined-basic"
                  label="State"
                  name="state"
                  variant="outlined"
                  fullWidth={true}
                  onChange={(e) => {
                    set_state(e.target.value);
                  }}
                  value={state}

                />
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  id="outlined-basic"
                  label="Country"
                  name="country"
                  variant="outlined"
                  fullWidth={true}
                  onChange={(e) => {
                    set_country(e.target.value);
                  }}
                  value={country}
                />
              </Grid>




            </Grid>
            <br /> <br />
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  id="outlined-basic"
                  label="Message"
                  name="message"
                  error={errors.message ? true : false}
                  variant="outlined"
                  fullWidth={true}
                  onChange={(e) => {
                    set_message(e.target.value);
                  }}
                  multiline
                  maxRows={3}
                  value={message}
                />
              </Grid>


            </Grid>
            <br /> <br />
            <Grid container spacing={3} className="mt-5">
              <Grid item xs={12} sm={4}></Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<SaveIcon />}
                  onClick={Submit}
                >
                  {is_edit === false ? "Submit" : "Update"}
                </Button>
              </Grid>
              <Grid item xs={12} sm={4}></Grid>
            </Grid>
          </Paper>

          <Grid className="mt-3"></Grid>
        </Grid>

        <Grid item xs={1} sm={2}></Grid>
      </Grid>

      <Footer />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));
